/* eslint-disable no-else-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-shadow */
import React, { useEffect, useRef, useState } from 'react'
import {
  Chip,
  TextField,
  Typography,
  Checkbox,
  Box,
  Button,
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { useStyles } from './styles'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const MultiSelect = ({
  label,
  onChange,
  options,
  values,
  reset,
  change,
  changeVertical,
  gnombredeleteNull
}) => {
  const [showScroll, setShowScroll] = useState(false)
  const classes = useStyles()
  const ref = useRef(label)

  useEffect(() => {
    console.log(values, '')
  }, [])

  const items = options
    .sort()
    .map((el) => ({ label: el, value: el, categorie: label }))
    .filter((el) => el.value !== '' && el.value !== '---VACIO---')

  const valuesFormated = values
    .sort()
    .map((el) => ({ label: el, value: el, categorie: label }))
    .filter((el) => el.value !== '' && el.value !== '---VACIO---')

  const optionsIncludes = items.filter((el) => values.includes(el.value))
  const [optionsShow, setOptionsShow] = useState(items)
  const [selectedOptions, setSelectedOptions] = useState(optionsIncludes)
  const [isDeleteNulls, setIsDeleteNulls] = useState(false)


  const  deleteNulls =() => {
    // (console.log(selectedOptions, 'selectedOptions' ))
    // console.log(gnombredeleteNull)
    if(!gnombredeleteNull){
      setSelectedOptions(selectedOptions.filter(item => item.label !== "NULL"));
      setIsDeleteNulls(true)
    }
    
  }

  useEffect(() => {
   
    if (selectedOptions && (label === 'Grupo nombre') && !isDeleteNulls) {
      console.log(gnombredeleteNull,"s")
      deleteNulls();
    }
  }, [selectedOptions])




  const handleToggleOption = (selectedOptions) => {
    setSelectedOptions(selectedOptions)
  }

  const getOptionLabel = (option) => `${option.label}`

  const handleSelectOne = (e, option) => {
    e.stopPropagation()
    handleToggleOption([option])
    onChange([option.value])
  }

  const handleSelectOneB = (option) => {
    if (option.categorie !== label) return
    handleToggleOption([option])
    onChange([option.value])
  }

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === 'select-option' || reason === 'remove-option') {
      handleToggleOption && handleToggleOption(selectedOptions)
      const arraySelected = selectedOptions.map((el) => el.value)
      return onChange(arraySelected)
    }
    if (reason == 'clear') {
      setSelectedOptions(valuesFormated)
    }
  }

  const handleSelectAll = () => {
    setSelectedOptions(items)
    const included = items.map((el) => el.value)
    return onChange(included)
  }

  const optionRenderer = (option, { selected }) => (
    <Box className={classes.container}>
      <Checkbox
        color="primary"
        icon={icon}
        checkedIcon={checkedIcon}
        checked={selected}
        style={{ marginRight: 8 }}
      />
      {getOptionLabel(option)}
      <button
        type="button"
        className={classes.button}
        onClick={(e) => handleSelectOne(e, option)}
      >
        SOLAMENTE
      </button>
    </Box>
  )
  const inputRenderer = (params) => (
    <div style={{ position: 'relative', marginTop: '40px' }}>
      <TextField {...params} variant="outlined" />
      <span className={classes.valueRendered}>
        {`${label} ( ${selectedOptions.length} )`}
      </span>
      <Button
        color="primary"
        onClick={handleSelectAll}
        className={classes.buttonSelectAll}
      >
        Seleccionar todas
      </Button>
    </div>
  )

  const getOptionSelected = (option, anotherOption) =>
    option.value === anotherOption.value

  useEffect(() => {
    change && setOptionsShow(valuesFormated)
    change && setSelectedOptions(valuesFormated)
    selectedOptions.length === 0 && setSelectedOptions(valuesFormated)
  }, [values])

  useEffect(() => {
    !change && setOptionsShow(items)
    reset && setSelectedOptions(valuesFormated)
  }, [options, reset])

  useEffect(() => {
    if (changeVertical) {
        handleSelectOneB(changeVertical)
    }
  }, [changeVertical])

  return (
    <Autocomplete
      multiple
      ref={ref}
      limitTags={1}
      options={optionsShow}
      value={selectedOptions}
      style={{ maxWidth: '400px', margin: '15px' }}
      id={label}
      disableCloseOnSelect
      className={classes.root}
      ListboxProps={{ style: { maxHeight: 200, overflow: 'auto' } }}
      ChipProps={{ style: { maxHeight: 200, overflow: 'auto' } }}
      disableClearable
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      renderTags={(value, getTagProps) => {
        if (showScroll) {
          return (
            <div className={classes.containerChipsScroll}>
              {value.map((option, index) => (
                <Chip
                  label={<Typography>{option.value}</Typography>}
                  {...getTagProps({ index })}
                  style={{
                    backgroundColor: 'white',
                    display: 'flex',
                    margin: '0 6px 0 0',
                  }}
                />
              ))}
            </div>
          )
        } else {
          return value.map((option, index) => (
            <Chip
              label={<Typography>{option.value}</Typography>}
              {...getTagProps({ index })}
              style={{
                backgroundColor: 'white',
                display: 'flex',
                margin: '0 6px 0 0',
              }}
            />
          ))
        }
      }}
      onChange={handleChange}
      onFocus={() => setShowScroll(true)}
      onBlur={() => setShowScroll(false)}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
    />
  )
}

export { MultiSelect }
